import { gsap, Power4} from "gsap"
import { config } from './site-config'
import { CustomEase } from "gsap/CustomEase"
import { Draggable } from "gsap/Draggable"
import { breakpoint} from './utilities/breakpoint-setup'

gsap.registerPlugin(CustomEase, Draggable)

let frameRate = 10
let rect = $('.grid')[0].getBoundingClientRect();
let mouse = {x: 0, y: 0, moved: false};
let animation = null
let move_grid_x = -$(window).width()
let move_grid_y = -$(window).height()
let move_grid_x_max = ($('.grid.js-grid').width() - $(window).width()) / 2
let move_grid_y_max = ($('.grid.js-grid').height() - $(window).height()) / 2
let animate = true
// let sm_hor = -$(window).width() / 100 * 10
// let sm_vert = -$(window).height() / 100 * 10
let logo_x = $(window).width() / 100 * 10
let logo_y =  $(window).height() / 100 * 10


function checkAnimate()
{
  frameRate -= 1
  if(frameRate === 2) {
    parallaxIt(".grid-center-logo-c", logo_x, logo_y)
  }
  if(frameRate < 0) {
    frameRate = 5
    parallaxIt(".grid", move_grid_x, move_grid_y)
  }
}

function parallaxIt(target, movement_x, movement_y) {
  if(animate) {
    animation = gsap.to(target, 1.3, {
      x: (mouse.x - rect.width / 2) / rect.width * movement_x,
      y: (mouse.y - rect.height / 2) / rect.height * movement_y,
      //ease: 'none'
    },
    0.1);
  }

}

function stopHeroAnimation()
{
  animate = false;
  if(animation) {
    animation.pause()
    gsap.to(animation, {duration: 0.1, progress: 0});
  }

}

function startHeroAnimation()
{
  animate = true
}

function heroBlockMoveAnimation() {

    $("body").on('mousemove', '.front-grid-c', function(e) {
      //mouse.moved = true;
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
      requestAnimationFrame(checkAnimate);
    });

    $("body").on('touchmove', '.front-grid-c', function(e) {

      //mouse.moved = true;
      mouse.x = e.touches[0].clientX - rect.left;
      mouse.y = e.touches[0].clientY - rect.top;
      requestAnimationFrame(checkAnimate);

    })


    $(window).on('resize scroll', function(){
      rect = $('.grid')[0].getBoundingClientRect();
    })


}

function heroBlockBlockDrag() {

  Draggable.create(".js-grid.is-mobile", {
      type:"x",
      edgeResistance:1,
      bounds:"#hero-grid", inertia:true});

}


let configuration = config()

if(configuration.heroMouseMove) {
  setTimeout(function (){

    if(breakpoint('screen') < breakpoint('lg')) {
      heroBlockBlockDrag()
    } else {
      heroBlockMoveAnimation()
    }

  }, 1500)
}

export { startHeroAnimation, stopHeroAnimation }